// Backend
import React from 'react';

// Frontend
import { Grid, Cell } from 'react-foundation';

// Functionality
import { useNavigate } from 'react-router-dom';

// Components
import { Header, ProgressBar, FlashMessage, ErrorRender } from '../../constants/SharedComponents';
import { useDemoContext } from '../../contexts/DemoContext';

export function DemoCompleted() {
  const navigate = useNavigate();
  const { demoData, addCompletedConversation } = useDemoContext();
  
  const [loading] = React.useState(false);
  const [error] = React.useState(null);
  const [flashMessageObject] = React.useState({});

  const handleReturnToDashboard = (e) => {
    e.preventDefault();
    
    // Create a new completed conversation entry
    const completedConversation = {
      id: `demo-completed-${Date.now()}`,
      organiserName: 'Jane Smith',
      attendeeName: 'You (Demo User)',
      attendeeEmail: 'demo.user@company.com',
      isOrganiserManager: true,
      isUserManager: false,
      isCanvasData: false,
      status: 2, // Complete
      employeePrepStatus: 2, // Complete
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      isDemo: true,
      selectedCategories: demoData.selectedCategories || [],
      canShareWithManager: demoData.canShareWithManager || false,
      isUserCreated: true // Flag to distinguish from static demo data
    };

    // Add the completed conversation to the demo data
    addCompletedConversation(completedConversation);
    
    // Navigate to the dashboard
    navigate('/demo/conversations');
  };

  return (
    <>
      <ProgressBar loading={loading} />
      <Header />
      <FlashMessage object={flashMessageObject} columnWrap={true} />
      <ErrorRender object={error} />

      <div className="grid-container">
        <Grid className="grid-padding-x">
          <Cell small={12}>
            <div className="page-content">
              <div className="page-content__header">
                <button
                  onClick={handleReturnToDashboard}
                  className="page-content__button--medium page-content__button--back"
                  id="page-navigation-button--go-back"
                >
                  Back to your Dashboard
                </button>
              </div>

              <h1 className="page-content__title">
                Thank you, your prep has been submitted
              </h1>

              <div className="page-content__styles">
                <p>
                  Your manager has been notified that you have completed your meeting
                  preparation.
                </p>
                <p>You can review this information at anytime from your dashboard.</p>
                <p>
                  <strong>Note:</strong> This was a demonstration. No real data has been stored or sent.
                </p>
              </div>

              {/* Show summary of what was submitted */}
              {demoData.selectedCategories && (
                <div className="page-content__styles">
                  <h2 className="page-content__subtitle">Demo Summary</h2>
                  <h3 className="page-content__subtitle page-content__subtitle--small">
                    Selected conversation topics:
                  </h3>
                  <ul>
                    {demoData.selectedCategories.map((category) => (
                      <li key={category.id}>{category.name}</li>
                    ))}
                  </ul>
                  <p>
                    <strong>Share with manager:</strong> {demoData.canShareWithManager ? 'Yes' : 'No'}
                  </p>
                </div>
              )}

              <div>
                <button
                  onClick={handleReturnToDashboard}
                  className="page-content__button--medium"
                  id="page-navigation-button--dashboard"
                >
                  Return to Demo Dashboard
                </button>
              </div>
            </div>
          </Cell>
        </Grid>
      </div>
    </>
  );
}
